<template>
  <el-row>
    <el-col :span="8">
      <h6>Subtotal</h6>
    </el-col>
    <el-col :span="12">
      {{ quantity }} Items
    </el-col>
    <el-col :span="4" class="text-right">
      {{ subtotal | currency }}
    </el-col>
  </el-row>
</template>

<script>
import {currency} from '../../../../filters';

export default {
  name: 'OrderUpdatePaymentSubtotal',
  filters: {
    currency,
  },
  props: {
    quantity: {
      type: Number,
      required: true,
    },
    subtotal: {
      type: Number,
      required: true,
    },
  },
};
</script>
